<p>Adds a throttle to a button to prevent multiple clicks.</p>
<p>
  Import the
  <app-text-code>ThrottleClickModule</app-text-code> in your app.module.ts
</p>

Properties:
<ul>
  <li><strong>throttleTime (optional, default: 300ms)</strong> click event will not be fired until that time is reached</li>
  <li><strong>throttleClick</strong> defines the action for the button</li>
</ul>

<example-viewer [example]="throttleClickComponent"></example-viewer>
